import { Rate, Input } from 'antd';
import { Modal } from '@insight-health-ai/roseate/components';
import { useState } from 'react';
import { PromiseOrValue } from '@insight-health-ai/roseate/utils';

export type RatingProps = {
  label?: string;
  defaultValue: number;
  onCompletion: ({
    value,
    comment,
  }: {
    value: number;
    comment: string;
  }) => PromiseOrValue<void>;
  modalOpen?: boolean;
};

export const Rating = ({
  label,
  defaultValue,
  onCompletion,
  modalOpen = true,
}: RatingProps) => {
  const [value, setValue] = useState(defaultValue);
  const [commentsModalOpen, setCommentsModalOpen] = useState(false);
  const [comment, setComment] = useState('');

  const handleChange = (value: number) => {
    setValue(value);
    if (modalOpen) {
      setCommentsModalOpen(true);
    } else {
      onCompletion({ value, comment: '' });
    }
  };

  const reset = (value?: number) => {
    setCommentsModalOpen(false);
    setValue(value ?? defaultValue);
    setComment('');
  };

  return (
    <div className="flex items-center gap-2 bg-gray-100/90 p-2 rounded-t-lg">
      {label && <span>{label}</span>}
      <Rate value={value} onChange={handleChange} allowClear={false} />
      {commentsModalOpen && (
        <Modal
          open={commentsModalOpen}
          onClose={async () => {
            await onCompletion({ value, comment });
            reset(value);
          }}
          secondaryAction={{
            label: 'Close',
          }}
          title="How can we improve?"
          primaryAction={{
            label: 'Submit',
            onClick: async () => {
              await onCompletion({ value, comment });
              reset(value);
            },
          }}
        >
          <Input.TextArea
            placeholder="Provide additional feedback (optional)"
            autoSize={{ minRows: 7, maxRows: 10 }}
            defaultValue={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Modal>
      )}
    </div>
  );
};
